import { observable, action, toJS, makeObservable } from "mobx";
import { DefaultFilter, FilteringMethod } from "./filters/DefaultFilter";
import { RenderCheckBox } from "./components/RenderCheckBox";
import { columnStructure, OFTableTypes } from "./OFTableTypes";
import keyboardJS from "keyboardjs";
import * as CSF from "../../components/OFTable/filters/CardSearchFilter";
import _ from "lodash";
import { message } from "antd";
import { v1 as uuid } from "uuid";

const possibleScreenSizes = ["xxl", "xl", "lg", "md", "sm"];

export class OFTableController {
  public props: OFTableTypes = null;

  public dataObj = "";
  public columnOrderKey = "";
  public controller = null;
  public scrollListRef = null;
  public columnOrderDefault = [];
  public columnOrderModal = [];
  public originalTableCols = [];
  public customLoader = null;

  // Used to ignore some scroll to row updates when the table gets the new data and the user has the row selected for example
  public scrolledToRowId = "";

  // Table settings
  public headerHeight = 72;
  public viewMode = "default"; // compact - default - detailed
  public tableRowHeight = 30;
  public checkboxColWidth = 35;
  public maxSelectAllCount = 0;

  public sortBy = null;
  public sortDirection = null;

  public canScrollTop = false;
  public showFilters = true;
  public showColTotals = false;
  public showTotalsMenu = false;
  public showFixedCols = false;
  public showColOrganiser = false;
  public loadingTable = false;
  public resizingCols = false;
  public showHideMultiSelected = false;

  public tableColStructure = {};
  public tableColStructureArray: Array<columnStructure> = [];
  public superHeaders = {};
  public pinnedRows = {};

  public columnOrder = [];

  public multiSelectedRows = { rows: {}, totSelected: 0 };
  public selectedRow = {
    row: null,
    rowData: null,
    fromTable: false,
  };
  public hiddenFilterValues = {};
  public totalColWidth = 0;
  public tableWidth = 0;
  public globalSearch = {
    query: "",
    selectedCols: [],
  };
  public contextMenu = {
    position: { y: 0, x: 0 },
    row: null,
    show: false,
  };

  public customColumnWidth = false;
  public currentEditableCell = null;

  // VList
  public offsetTop = 0;
  public offsetLeft = 0;

  public tableHeight = 0;

  public lastSearch = "";

  // For column reorder
  columnReorderConfig: any = [];

  //--CARDS VALUES----------------------------------------------------
  public mobileRender = false;
  public screenSize = "xxl"; // 'xxl' | 'xl' | 'lg' | 'md' | 'sm'
  public renderedScreenSizes = ["xxl", "xl", "lg", "md", "sm"];
  public columnCardFlag = false;
  public hiddenTableColStructure = {};
  //------------------------------------------------------

  // Controller for accessing original controller and data for the table
  constructor(props: OFTableTypes) {
    this.setProps(props);
    this.controller = props.controller;
    this.dataObj = props.dataObj;
    this.customLoader = props.customLoader;
    this.columnOrderKey = "OFTable-" + window.location.pathname.replace("/", "") + props.dataObj + "ColumnOrder";
    this.setTableRowHeight(props.tableRowHeight || this.tableRowHeight);
    this.setCustomColumnWidth(JSON.parse(localStorage.getItem(props.dataObj)) ? true : false);
    this.maxSelectAllCount = props.maxSelectAllCount || 0;
    this.setLoadingTable(props.loading);
    this.initTable(props);

    if (props.hideFilters) {
      this.showHideFilters(true);
    }

    if (props.compactMode) {
      this.viewModeChange("compact");
    }

    if (props.tableInstance) {
      props.tableInstance(this);
    }

    // To disable text highlighting when selecting the rows using shift key
    // Only set if the checkboxes are showing (multiselect enabled)
    if (props.showCheckbox !== false) {
      document.onselectstart = () => {
        if (this.shiftKeyActive) {
          return false;
        }
      };
    }

    makeObservable(this, {
      props: observable,
      dataObj: observable,
      columnOrderKey: observable,
      controller: observable,
      scrollListRef: observable,
      columnOrderDefault: observable,
      columnOrderModal: observable,
      originalTableCols: observable,
      customLoader: observable,
      scrolledToRowId: observable,
      headerHeight: observable,
      viewMode: observable,
      tableRowHeight: observable,
      checkboxColWidth: observable,
      maxSelectAllCount: observable,
      sortBy: observable,
      sortDirection: observable,
      canScrollTop: observable,
      showFilters: observable,
      showColTotals: observable,
      showTotalsMenu: observable,
      showFixedCols: observable,
      showColOrganiser: observable,
      loadingTable: observable,
      resizingCols: observable,
      showHideMultiSelected: observable,
      tableColStructure: observable,
      tableColStructureArray: observable,
      superHeaders: observable,
      pinnedRows: observable,
      columnOrder: observable,
      multiSelectedRows: observable,
      selectedRow: observable,
      hiddenFilterValues: observable,
      totalColWidth: observable,
      tableWidth: observable,
      globalSearch: observable,
      contextMenu: observable,
      customColumnWidth: observable,
      currentEditableCell: observable,
      offsetTop: observable,
      offsetLeft: observable,
      tableHeight: observable,
      lastSearch: observable,
      columnReorderConfig: observable,
      //card
      mobileRender: observable,
      screenSize: observable,
      renderedScreenSizes: observable,
      columnCardFlag: observable,
      hiddenTableColStructure: observable,

      setOriginalTableCols: action,
      setTableColStructureArray: action,
      setHeaderHeight: action,
      setMobileRender: action,
      setScreenSize: action,
      setRenderedScreenSizes: action,
      setColumnCardFlag: action,
      setHiddenTableColStructure: action,
      setCanScrollTop: action,
      setScrolledToRowId: action,
      //ACTIONS
      setShowFilters: action,
      setContextMenu: action,
      setLastColWidth: action,
      setScrollListRef: action,
      setLoadingTable: action,
      setProps: action,
      setGlobalSearch: action,
      setSelectedRow: action,
      setResizingCols: action,
      setTotalColWidth: action,
      setCustomColumnWidth: action,
      setSuperHeaders: action,
      setTableColStructure: action,
      setCurrentEditableCell: action,
    });
  }
  //------------------------SETTERS--------------------------------------------------------------

  setOriginalTableCols(value) {
    this.originalTableCols = value;
  }

  setTableColStructureArray(value: Array<columnStructure>) {
    this.tableColStructureArray = value;
  }

  setHeaderHeight(value: number) {
    this.headerHeight = value;
  }

  setCanScrollTop(state: boolean) {
    this.canScrollTop = state;
  }
  setScrolledToRowId(value: string) {
    this.scrolledToRowId = value;
  }

  setMobileRender(state: boolean) {
    this.mobileRender = state;
  }
  setScreenSize(value: string) {
    this.screenSize = value;
  }
  setRenderedScreenSizes(value: Array<any>) {
    this.renderedScreenSizes = value;
  }
  setColumnCardFlag(state: boolean) {
    this.columnCardFlag = state;
  }
  setHiddenTableColStructure(value: any, key: string = null) {
    if (key) {
      this.hiddenTableColStructure[key] = { ...value };
    } else {
      this.hiddenTableColStructure = value;
    }
  }

  public setTableColStructure(columnId: string, key: string, value: any) {
    if (columnId === null) {
      this.tableColStructure = value;
    } else {
      if (key === "all") {
        this.tableColStructure[columnId] = value;
      } else {
        this.tableColStructure[columnId][key] = value;
      }
    }
  }

  public setSuperHeaders(columnId: string, key: string, value: any) {
    if (columnId === null) {
      this.superHeaders = value;
    } else {
      if (key === "all") {
        this.superHeaders[columnId] = value;
      } else {
        this.superHeaders[columnId][key] = value;
      }
    }
  }

  public setCurrentEditableCell(state: any) {
    this.currentEditableCell = state;
  }

  public setShowFilters(state: boolean) {
    this.showFilters = state;
  }

  public setResizingCols(state: boolean) {
    this.resizingCols = state;
  }

  public setCustomColumnWidth(state: boolean) {
    this.customColumnWidth = state;
  }

  public setTableRowHeight(state: number) {
    this.tableRowHeight = state;
  }

  public setTotalColWidth(state: number) {
    this.totalColWidth = state;
  }

  public setContextMenu(key: string, value: any) {
    if (key === "all") {
      this.contextMenu = value;
    } else {
      this.contextMenu[key] = value;
    }
  }

  public setScrollListRef(state: any) {
    this.scrollListRef = state;
  }

  public setLoadingTable(state: any) {
    this.loadingTable = state;
  }

  public setProps(state: any) {
    this.props = state;
  }

  public setGlobalSearch(key: string, value: any) {
    if (key === "all") {
      this.globalSearch = value;
    } else {
      this.globalSearch[key] = value;
    }
  }

  public setSelectedRow(state: any) {
    this.selectedRow = state;
  }

  //--------------------------------------------------------------------------------------

  // Initiate the table columns + additional structure
  public initTable = action((props: OFTableTypes) => {
    this.computeColumns(props.columns);

    // If the table has default sorting prop
    if (this.props?.defaultSortBy) {
      this.sortBy = this.props.defaultSortBy.id;
      this.sortDirection = this.props.defaultSortBy.direction;
    }

    // MultiSelect rows if the table has this prop defined
    // (because the table might not be initiated when the rows were selected from the map)
    if (this.props?.multiSelectedObj && this.controller[this.props?.multiSelectedObj.name].length > 0) {
      this.selectRowsOnInit();
    }

    // Select the row if the table has this prop defined
    // (because the table might not be initiated when the row was selected from the map)
    if (this.props?.selectRowObj && this.controller[this.props?.selectRowObj]) {
      this.selectRowOnInit();
    }

    // Set table option values from the cookies if they exist
    this.setOptionsFromCookie();

    // Add key listeners if the selectRowUsingKeys is enabled
    if (_.get(this.props, "selectRowUsingKeys.active", false)) {
      this.addKeyListeners();
    }
  });

  // Check if the table is visible - for example if the table (or parent) element is set to display none
  // To avoid the scrolling to row issues
  get tableIsVisible() {
    if (!this.scrollListRef) {
      return false;
    }

    const element = this.scrollListRef.elements().content;

    return element.offsetWidth > 0 && element.offsetWidth > 0;
  }

  get innerHeight() {
    // console.log("innerHeight ", this.sortedFilteredList.length);
    // console.log("innerHeight ", this.tableRowHeight);
    // console.log("innerHeight ", this.headerHeight);

    return this.sortedFilteredList.length * this.tableRowHeight + this.headerHeight;
  }

  get innerWidth() {
    return this.totalColWidth > this.tableWidth ? this.totalColWidth : this.tableWidth;
  }

  get tableListHeight() {
    return this.tableHeight - this.headerHeight;
  }

  get isFilterVisible() {
    return this.showFilters && (this.tableData.length > 0 || (this.tableData.length === 0 && this.filteredColumns.length > 0));
  }

  get getRowPointers() {
    const startIndex = Math.min(this.sortedFilteredList.length, Math.floor(this.offsetTop / this.tableRowHeight));
    const tableRows = Math.floor((this.offsetTop + this.tableListHeight) / this.tableRowHeight);

    let endIndex = Math.min(this.sortedFilteredList.length, tableRows);

    // If the actual data is less than the rows we can fit in the table, dont render last row
    if (tableRows > endIndex) {
      endIndex -= 1;
    }

    const row = [];

    for (let i = startIndex; i <= endIndex; i++) {
      row.push({
        index: i,
      });
    }

    return row;
  }

  public rowPositioning = (height) => {
    const rowCount = Math.floor((height - this.headerHeight) / this.tableRowHeight);
    const leftOver = height - this.headerHeight - rowCount * this.tableRowHeight;

    let availRowCount = Math.min(rowCount, this.sortedFilteredList.length);

    return { availRowCount: availRowCount, leftOver: leftOver > 0 ? this.tableRowHeight - leftOver : 0 };
  };

  public handleScrolling = action((e) => {
    // console.log('handleScrolling')
    const elements = e.elements();

    this.offsetTop = elements.content.scrollTop;
    this.offsetLeft = elements.content.scrollLeft;

    if (this.props.pagination && this.props.pagination.infiniteScrolling && !this.loadingTable && this.tableData.length !== this.props.pagination.total) {
      const tableRows = Math.floor((this.offsetTop + this.tableListHeight) / this.tableRowHeight);

      let endIndex = Math.min(this.sortedFilteredList.length, tableRows);

      if (this.sortedFilteredList.length - endIndex <= this.props.pagination.infiniteScrollOffset) {
        this.props.pagination.pageChange(this.props.pagination.currentPage + 1, true, true);
      }
    }

    if (elements.content.scrollTop > 0) {
      this.setCanScrollTop(true);
    } else {
      this.setCanScrollTop(false);
    }
  });

  get visibleColumns(): any {
    return this.tableColStructureArray.filter((tc) => tc.show);
  }

  get columnsAvailableForSearch() {
    return this.visibleColumns.filter((col: columnStructure) => !col.disableFilters && col.enableGlobalSearch);
  }

  get fixedRows(): any {
    if (this.props?.maxPinnedRows && !_.isEmpty(this.pinnedRows)) {
      return Object.values(this.pinnedRows).length;
    }

    return 0;
  }

  get fixedColumns(): any {
    // If the prop is enabled for this table, and the option is selected - show fixed columns
    if (this.props?.fixedColumns && this.showFixedCols) {
      // If the table has checkboxes, fix them as well
      if (this.props?.showCheckbox !== false) {
        return this.props.fixedColumns + 1;
      } else {
        return this.props.fixedColumns;
      }
    }

    return 0;
  }

  get moreOptionsWarning() {
    if (!this.showFilters || this.viewMode !== "default" || this.showFixedCols) {
      return true;
    }

    return false;
  }

  get shiftKeyActive() {
    return this.props?.shiftKeyFlag && this.controller[this.props?.shiftKeyFlag];
  }

  get multiselectionActive() {
    return this.props?.multiSelectRowObj && this.controller[this.props?.multiSelectRowObj];
  }

  get filteredColumns(): any {
    return Object.values(this.tableColStructure).filter((col: any) => col.finalFilterValue !== "");
  }

  get tableData(): any {
    // To make sure it renders the list for large datasets
    // (as the large data will not be set to observable to save memory and performance)
    if (this.loadingTable) {
      return [];
    }

    return _.get(this.controller, this.dataObj, []);
  }

  get sortedList(): Array<any> {
    if (_.get(this.props?.pagination, "serverSideSortFilter")) {
      return this.tableData;
    }

    if (this.sortBy || !_.isEmpty(this.pinnedRows)) {
      const column = this.tableColStructure[this.sortBy];

      if (!column) {
        return this.tableData;
      }

      const valueType = column.rawValue ? typeof column.rawValue({}) : typeof column.accessor({});

      const orderedData = _.orderBy(
        this.tableData,
        (row) => {
          if (column) {
            // If rawValue provided, sort by this value
            let value = column.rawValue ? column.rawValue(row) : column.accessor(row);

            if (typeof value === "string") {
              value = value.trim().toLowerCase();
            }

            if (!value && typeof value !== "boolean") {
              switch (valueType) {
                case "number": {
                  return column.excludeZero ? (this.sortDirection === "desc" ? 0 : Infinity) : value;
                }
                default:
                  return this.sortDirection === "desc" ? "" : "||||||";
              }
            }

            return value;
          }
        },
        this.sortDirection
      );

      // Sort the pinned rows to the top no matter what sorting enabled
      if (!_.isEmpty(this.pinnedRows)) {
        return _.sortBy(orderedData, (a: any) => {
          if (this.pinnedRows[a._id]) {
            return false;
          } else {
            return true;
          }
        });
      }

      return orderedData;
    } else {
      return this.tableData;
    }
  }

  get sortedFilteredList() {
    if (_.get(this.props?.pagination, "serverSideSortFilter")) {
      return this.sortedList;
    }

    const columns: any = this.filteredColumns;
    let filteredData = this.sortedList;

    // Check if the flag is enabled to show only the selected rows
    if (this.showHideMultiSelected && this.multiSelectedRows.totSelected > 0) {
      filteredData = this.sortedList.filter((data) => this.multiSelectedRows.rows[data._id]);
    }

    if (!_.isEmpty(this.hiddenFilterValues) || columns.length > 0) {
      filteredData = this.sortedList.filter((data) => {
        let found = 0;
        let foundHidden = 0;

        if (this.pinnedRows[data._id]) {
          return true;
        }

        Object.keys(this.hiddenFilterValues).forEach((key) => {
          if (FilteringMethod(_.get(data, key), this.hiddenFilterValues[key])) {
            foundHidden++;
          }
        });

        columns.forEach((col: any) => {
          let value = col.rawFilterValue ? col.rawFilterValue(data) : col.accessor(data);

          if (col.filterMethod) {
            // if (col.filterMethod(value, col.finalFilterValue, data, col.id)) {
            if (col.filterMethod(value, col.finalFilterValue, data, col.id, col)) {
              found++;
            }
          } else {
            if (FilteringMethod(value, col.finalFilterValue)) {
              found++;
            }
          }
        });

        const showItem = found === columns.length && foundHidden === Object.values(this.hiddenFilterValues).length;

        // If the filtering applied and we have the showHideMultiSelected flag enabled, apply the filtering only to the selected rows
        if (this.showHideMultiSelected && this.multiSelectedRows.totSelected > 0) {
          return showItem && this.multiSelectedRows.rows[data._id];
        }

        return showItem;
      });
    }

    if (this.props?.globalSearch && this.globalSearch.query) {
      filteredData = filteredData.filter((data) => {
        let found = false;

        this.tableColStructureArray.forEach((col) => {
          if (col.show && !found && col.enableGlobalSearch && this.globalSearch.selectedCols.includes(col._id)) {
            let value = col.rawFilterValue ? col.rawFilterValue(data) : col.accessor(data);

            if (value && typeof value === "string" && value.toLocaleLowerCase().includes(this.globalSearch.query.toLocaleLowerCase())) {
              found = true;
            }
          }
        });

        return found;
      });
    }

    return filteredData;
  }

  private handleTableCardChange = () => {
    this.setColumnCardFlag(!this.columnCardFlag);
    this.computeColumns(this.props?.columns);
  };

  private handleResponsiveScreen = () => {
    let screenWidth = window.screen.width;

    let newScreenSize;

    if (screenWidth < 576) {
      this.setMobileRender(true);
      newScreenSize = "sm";
    } else if (screenWidth < 768) {
      this.setMobileRender(true);
      newScreenSize = "md";
    } else if (screenWidth < 992) {
      this.setMobileRender(false);
      newScreenSize = "lg";
    } else if (screenWidth < 1200) {
      this.setMobileRender(false);
      newScreenSize = "xl";
    } else if (screenWidth < 1600) {
      this.setMobileRender(false);
      newScreenSize = "xxl";
    } else {
      this.setMobileRender(false);
      newScreenSize = "xxl";
    }

    if (this.screenSize !== newScreenSize) {
      this.setScreenSize(newScreenSize);

      let foundScreenSizeIndex = possibleScreenSizes.findIndex((ss) => ss === this.screenSize);
      this.setRenderedScreenSizes(possibleScreenSizes.slice(foundScreenSizeIndex, 5));

      this.computeColumns(this.props?.columns);
    }
  };

  public setLastColWidth = (width?, height?) => {
    if (height) {
      this.tableHeight = height;
    }

    if (width) {
      this.tableWidth = width;
    }

    // console.log('setLastColWidth ', this.tableHeight)
    // console.log('setLastColWidth ', this.tableWidth)

    this.handleResponsiveScreen();

    // console.log("setLastColWidth", this.tableColStructure);
    // console.log("tableWidth", this.tableWidth);
    // console.log("totalColWidth", this.totalColWidth);

    if (this.tableColStructure["OFTable_lastCol"]) {
      let width = this.tableWidth - this.totalColWidth > 0 ? this.tableWidth - this.totalColWidth : 0;

      //console.log("last column width =", width);
      this.setTableColStructure("OFTable_lastCol", "width", width);
    }
  };

  private prepareColumns = (col, superHeader = null) => {
    // console.log(col);
    // If the column requires responsive rendering check if its possible to view in the current screen size
    if (!this.columnCardFlag && col.responsiveRender && !this.renderedScreenSizes.includes(col.responsiveRender)) {
      if (col.show) {
        this.setHiddenTableColStructure(col, col.id);
      }

      return;
    }

    // If the column is of type card, don't prepare it
    if (col.id === "card") {
      return;
    }

    // If the column is set to not be shown, don't prepare it
    if (col.show !== true) {
      return;
    }

    // If the column has no width defined
    if (!col.width) {
      col.width = 60;
    }

    //Check if the column has totals prop so we can enable "Show Totals" menu option
    if (col.showTotals) {
      this.showTotalsMenu = true;
    }

    const colWidth = this.getColumnWidthCookie(col.id) || col.width;

    const additionalColumnProps = {
      filterValue: "",
      width: colWidth,
      finalFilterValue: "",
      filterOnSubmit: col.filterOnSubmit || _.get(this.props?.pagination, "serverSideSortFilter") ? true : false,
      _id: uuid(),
    };

    // If column has super header, add its structure
    if (superHeader) {
      if (this.superHeaders[superHeader.id]) {
        let newWidth = this.superHeaders[superHeader.id].width + colWidth;
        this.setSuperHeaders(superHeader.id, "width", newWidth);
        additionalColumnProps["superHeader"] = { id: superHeader.id };
      } else {
        this.setSuperHeaders(superHeader.id, "all", { width: colWidth, title: superHeader.Header });
        additionalColumnProps["superHeader"] = { id: superHeader.id, index: 1 };
      }
    }
    let totalColWidth = this.totalColWidth + colWidth;
    this.setTotalColWidth(totalColWidth);

    this.setTableColStructure(col.id, "all", { ...col, ...additionalColumnProps });
  };

  public handleSorting = action((dataKey) => {
    // If the column has disableSortBy set to true, ignore sorting
    if (this.tableColStructure[dataKey].disableSortBy || this.tableData.length === 0) {
      return;
    }

    if (dataKey === _.get(this.props?.defaultSortBy, "id") && dataKey === this.sortBy) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else if (dataKey === this.sortBy) {
      if (this.sortDirection === "desc") {
        this.resetSorting(false);
      } else {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      }
    } else {
      this.sortBy = dataKey;
      this.sortDirection = "asc";
    }

    if (this.props?.editableCells) {
      this.handleCellEdit();
    }

    if (_.get(this.props?.pagination, "serverSideSortFilter")) {
      this.props?.pagination.serverSideSortFilter(this.getServerSideFilters(true));
    }
  });

  public renderFilterComponent = (column) => {
    if (column.Filter) {
      return column.Filter({ column, handleFilter: (column, type) => this.handleSortFilter(column, type) });
    }

    if (column.CardFilter) {
      return column.CardFilter({ column, handleFilter: (column, type) => this.handleSortFilter(column, type) });
    }

    return DefaultFilter({ column, handleFilter: (column, type) => this.handleSortFilter(column, type) });
  };

  public handleSortFilter = (column = null, type = null) => {
    if (column) {
      column.finalFilterValue = column.filterValue;
      column.filterType = type;
    }

    // Check if the server side is enabled and that the last searched value is not the same as current
    if (_.get(this.props?.pagination, "serverSideSortFilter") && this.lastSearch !== column?.filterValue) {
      this.props.pagination.serverSideSortFilter(this.getServerSideFilters());
      this.lastSearch = column?.filterValue;
    }
  };

  public getServerSideFilters = (onlySorting = false) => {
    return {
      filterBy: this.filteredColumns.map((col) => this.prepareServerSideFilters(col)),
      sortBy: this.sortBy ? { colId: this.sortBy, direction: this.sortDirection } : {},
      onlySorting: onlySorting,
    };
  };

  private prepareServerSideFilters = (col) => {
    switch (col.filterType) {
      case "date": {
        return {
          colId: col.id,
          value: {
            gte: col.finalFilterValue[0],
            lte: col.finalFilterValue[1],
          },
          type: col.filterType,
        };
      }

      case "state":
        return {
          colId: col.id,
          value: col.finalFilterValue,
          type: col.filterType,
        };

      case "numerical": {
        let val = null;

        if (col.finalFilterValue.type === "includes") {
          val = Number(col.finalFilterValue.value);
        }

        if (col.finalFilterValue.type === "greaterThan") {
          val = { gt: Number(col.finalFilterValue.value) };
        }

        if (col.finalFilterValue.type === "lessThan") {
          val = { lt: Number(col.finalFilterValue.value) };
        }

        if (col.finalFilterValue.type === "between") {
          val = {
            gte: Number(col.finalFilterValue.value[0]),
            lte: Number(col.finalFilterValue.value[1]),
          };
        }

        return {
          colId: col.id,
          value: val,
          type: col.filterType,
        };
      }

      case "multiSelect":
        return {
          colId: col.id,
          value: Object.keys(col.finalFilterValue),
          type: col.filterType,
        };

      default:
        return { colId: col.id, value: { inc: col.finalFilterValue }, type: col.filterType };
    }
  };

  public handleFilter = (value, column) => {
    column.filterValue = value;
  };

  // Use this func to apply a filter value using tables instance
  public setFilterValue = (colId: string, value) => {
    const column = this.visibleColumns.find((c) => c.id === colId);

    if (column) {
      column.filterValue = value;
      column.finalFilterValue = value;
    }
  };

  public resizeRow = action((column, { deltaX }, event, finished = false) => {
    event.preventDefault();
    // console.log("resizeRow");
    if (finished) {
      this.setColumnWidthCookie(column);

      this.setResizingCols(false);
    } else {
      if (column.superHeader) {
        let newWidth = this.superHeaders[column.superHeader.id].width + deltaX;
        this.setSuperHeaders(column.superHeader.id, "width", newWidth);
      }

      column.width += deltaX;

      let totalColWidth = this.totalColWidth + deltaX;
      this.setTotalColWidth(totalColWidth);
      this.setResizingCols(true);
      this.setLastColWidth();
    }
  });

  public killClick = (e) => e.stopPropagation();

  public resetAllFilters = action((resetSortFilters = true) => {
    this.filteredColumns.forEach((col: any) => {
      col.filterValue = "";
      col.finalFilterValue = "";
      col.filterType = "";
    });
    this.hiddenFilterValues = {};

    if (this.props?.globalSearch) {
      this.setGlobalSearch("all", {
        query: "",
        selectedCols: [],
      });
    }

    resetSortFilters && this.handleSortFilter();
  });

  public resetSorting = action((resetSortFilters = true) => {
    if (this.props?.defaultSortBy) {
      this.sortBy = this.props.defaultSortBy.id;
      this.sortDirection = this.props.defaultSortBy.direction;
    } else {
      this.sortBy = null;
      this.sortDirection = null;
    }

    if (_.get(this.props?.pagination, "serverSideSortFilter") && resetSortFilters) {
      this.props.pagination.serverSideSortFilter(this.getServerSideFilters(true));
    }
  });

  public resetTable = action(() => {
    this.resetAllFilters();
    this.resetSorting(false);
    this.scrollListRef.scroll({ x: 0, y: 0 });
  });

  public resetMultiselectedRows = action(() => {
    this.multiSelectedRows = { rows: {}, totSelected: 0 };

    // Reset the flag if the showHideMultiSelected is enabled but all the rows were unselected
    if (this.showHideMultiSelected && this.multiSelectedRows.totSelected === 0) {
      this.showHideMultiSelected = false;
    }
  });

  public resetSelectedRow = () => {
    this.setSelectedRow({
      row: null,
      rowData: null,
      fromTable: false,
    });

    // Reset the flag if the showHideMultiSelected is enabled but all the rows were unselected
    if (this.showHideMultiSelected && this.multiSelectedRows.totSelected === 0) {
      this.showHideMultiSelected = false;
    }
  };

  public scrollToRow = (top = false, forceScroll = false) => {
    // console.log('scrollToRow')
    // If the ref is not defined or the update is triggered while resizing cols - ignore
    if (!this.scrollListRef || this.resizingCols || !this.tableIsVisible) {
      return;
    }

    // If the row is selected and the table updates (switching tabs, getting new data), ignore scrolling to row
    if (!forceScroll && this.selectedRow.row === this.scrolledToRowId && !top) {
      return;
    }

    // If the scroll to is called just to scroll to the top, ignore the rest
    if (top) {
      const { viewport } = this.scrollListRef.elements();

      // Just scroll back to top
      viewport.scroll({ left: this.offsetLeft, top: 0 });
      return;
    }

    let rowIndex = -1;

    if (this.selectedRow) {
      rowIndex = this.sortedFilteredList.findIndex((data) => data._id === this.selectedRow.row);
    }

    if (~rowIndex) {
      const { viewport } = this.scrollListRef.elements();
      const midOffset = (this.tableListHeight - this.tableRowHeight) / 2;

      // Scroll to the row
      viewport.scroll({ left: this.offsetLeft, top: rowIndex * this.tableRowHeight - midOffset });
    }

    // Update the scrolled to row id
    this.setScrolledToRowId(this.selectedRow.row);
  };

  public handleRowSelection = (row, fromTable = false, forceScroll = false) => {
    this.setSelectedRow({
      row: row._id,
      rowData: row,
      fromTable: fromTable,
    });

    // If the handleRowSelection is called not from the table itself and the table is visible, scroll to row
    if (!fromTable) {
      this.scrollToRow(false, forceScroll);
    } else {
      this.scrolledToRowId = this.selectedRow.row;
    }

    this.resetMultiselectedRows();
  };

  public selectRowUsingKeys = (up = false) => {
    if (!this.selectedRow.row || this.multiselectionActive || this.shiftKeyActive || !this.tableIsVisible) {
      return;
    }

    const rowIndex = this.sortedFilteredList.findIndex((row) => row._id === this.selectedRow.row);

    if (~rowIndex) {
      if (up && rowIndex !== 0) {
        this.handleRowClick(this.sortedFilteredList[rowIndex - 1], false);
      }

      if (!up && rowIndex !== this.sortedFilteredList.length - 1) {
        this.handleRowClick(this.sortedFilteredList[rowIndex + 1], false);
      }
    }
  };

  public multiselectRows = (row, selectAllValue, selectAll = false, passProps = true) => {
    const checked = selectAllValue;

    // If selection is done from the header checkbox to select it all
    if (selectAll) {
      const allRows = {};

      if (!checked) {
        this.resetMultiselectedRows();
        passProps && this.passProps("onMultiSelection", [this.sortedFilteredList, false]);
      } else {
        this.sortedFilteredList.forEach((r) => {
          allRows[r._id] = r._id;
        });
        this.multiSelectedRows.rows = allRows;
        this.multiSelectedRows.totSelected = this.sortedFilteredList.length;
        passProps && this.passProps("onMultiSelection", [this.sortedFilteredList, true]);
      }
    }
    // Else select/unselect single row
    else {
      // Check if user already selected single row so we include it as well (only when holding ctrl)
      if (this.selectedRow.row && this.multiselectionActive) {
        // Add additional row if the multiselected row is not the same as selected row
        if (this.selectedRow.row !== row._id) {
          this.multiSelectedRows.rows[this.selectedRow.row] = this.selectedRow.row;
          this.multiSelectedRows.totSelected++;
          passProps && this.passProps("onMultiSelection", [this.selectedRow.rowData, true]);
        }
      }

      if (this.multiSelectedRows.rows[row._id]) {
        delete this.multiSelectedRows.rows[row._id];
        this.multiSelectedRows.totSelected--;
        passProps && this.passProps("onMultiSelection", [row, false]);
      } else {
        this.multiSelectedRows.rows[row._id] = row._id;
        this.multiSelectedRows.totSelected++;
        passProps && this.passProps("onMultiSelection", [row, true]);
      }
      this.resetSelectedRow();
    }
  };

  public passProps = (objName, params) => {
    if (this.props[objName]) {
      this.props[objName](...params);
    }
  };

  public selectRowsInSuccession = action((row, passProps) => {
    const selectedRows = {};
    const selectedRawRows = [];

    let foundRows = 0;

    this.sortedFilteredList.forEach((r) => {
      // Start selection is selected row matches
      if (r._id === this.selectedRow.row || row._id === r._id) {
        foundRows++;
      }

      // Detect the selection to be in between 2 selected rows
      if (foundRows === 1 || foundRows === 2) {
        selectedRows[r._id] = r._id;
        selectedRawRows.push(r);
      }

      // If the selected row is the same as the one selected using shift
      // Or both selected rows were found - reset
      if (this.selectedRow.row === row._id || foundRows === 2) {
        foundRows = 0;
      }
    });

    this.multiSelectedRows.rows = selectedRows;
    this.multiSelectedRows.totSelected = Object.values(selectedRows).length;
    this.resetSelectedRow();
    passProps && this.passProps("onMultiSelection", [selectedRawRows, true]);
  });

  public handleRowClick = (data, fromTable = true) => {
    // If the row was selected while multiselecting, ignore the rest of the logic
    if (this.multiselectionActive) {
      this.multiselectRows(data, null);
      return;
    }

    if (this.shiftKeyActive && this.selectedRow.row) {
      this.selectRowsInSuccession(data, this.props.onMultiSelection);
      return;
    }

    // If the table has onRowClick prop, pass the data to the prop
    if (!this.columnCardFlag && this.props?.onRowClick) {
      this.props.onRowClick(data);
    }

    if (this.columnCardFlag && this.props?.onCardClick) {
      this.props.onCardClick(data);
    }

    this.handleRowSelection(data, fromTable);
  };

  public handleCellEdit = (rowIndex?, columnIndex?) => {
    if (rowIndex !== undefined && columnIndex !== undefined) {
      this.setCurrentEditableCell(this.getRowPointers[rowIndex].index.toString() + columnIndex.toString());
    } else {
      this.setCurrentEditableCell(null);
    }
  };

  public handleRightClick = action(({ event, rowData }) => {
    event.preventDefault();

    // If the table has multiselected rows and the user clicks on the row which is not multiselected - clear all multiselections
    if (!_.isEmpty(this.multiSelectedRows.rows) && !this.multiSelectedRows.rows[rowData._id]) {
      this.resetRightClickMultiselected();
    }

    this.setContextMenu("all", {
      show: true,
      row: rowData,
      position: { y: event.clientY, x: event.clientX },
    });
  });

  public resetRightClickMultiselected = action(() => {
    this.props?.resetSelection && this.props.resetSelection();
    this.resetMultiselectedRows();
    this.resetSelectedRow();
  });

  public setHiddenFilterValue = (colId: string, value: string) => {
    this.hiddenFilterValues[colId] = value;
  };

  public getColumnWidthCookie = (colId?) => {
    const columnWidths = JSON.parse(localStorage.getItem(this.dataObj));

    if (columnWidths && colId) {
      return columnWidths[colId];
    }

    return columnWidths;
  };

  public setColumnWidthCookie = (column) => {
    const sizes = JSON.parse(localStorage.getItem(this.dataObj)) || {};
    sizes[column.id] = column.width;

    localStorage.setItem(this.dataObj, JSON.stringify(sizes));
    this.setCustomColumnWidth(true);
  };

  public setOptionsFromCookie = () => {
    const options = JSON.parse(localStorage.getItem(this.dataObj + "Options"));

    if (options) {
      if (options.showFilters === false) {
        this.showHideFilters(true);
      }

      if (options.viewMode) {
        this.viewModeChange(options.viewMode);
      }

      if (options.fixedColumns && this.props?.fixedColumns) {
        this.enableDisableFixedCols(true);
      }
    }
  };

  public checkViewMode = () => {
    const options = JSON.parse(localStorage.getItem(this.dataObj + "Options"));

    if (options) {
      if (this.viewMode === "card" || options.viewMode === "card") {
        this.setHiddenTableColStructure({});
        this.viewModeChange("default");
      }
    }
  };

  public resetColumnWidth = action(() => {
    let total = this.props?.showCheckbox !== false ? this.checkboxColWidth : 0;

    // console.log(total);
    // console.log("Before: ", this.originalTableCols);

    this.originalTableCols.forEach((col: any) => {
      // Check if colum has sub columns
      if (col.subColumns) {
        if (this.superHeaders[col.id]) {
          this.setSuperHeaders(col.id, "width", 0);
        }

        col.subColumns.forEach((subCol) => {
          if (subCol.show !== false) {
            this.setTableColStructure(subCol.id, "width", subCol.width);

            let newWidth = this.superHeaders[col.id].width + subCol.width;
            this.setSuperHeaders(col.id, "width", newWidth);

            total += subCol.width;
          }
        });
      } else {
        if (col.show && col?.width) {
          // console.log("HERE");
          // console.log(col.id + ": " + col.width);

          this.setTableColStructure(col.id, "width", col.width);
          total += col.width;
        }
      }
    });

    // console.log(total);
    // console.log("After: ", this.originalTableCols);

    localStorage.removeItem(this.dataObj);
    this.setCustomColumnWidth(false);
    this.setTotalColWidth(total);
    this.setLastColWidth();
  });

  public selectRowsOnInit = action(() => {
    const { name, accessor } = this.props?.multiSelectedObj;

    this.sortedFilteredList.forEach((row) => {
      const match = this.controller[name].some((data) => {
        if (typeof data === "object") {
          return _.get(data, accessor) === _.get(row, accessor);
        }

        if (typeof data === "string") {
          return data === _.get(row, accessor);
        }
      });

      if (match) {
        this.multiSelectedRows.rows[row._id] = row._id;
      }
    });

    this.multiSelectedRows.totSelected = this.controller[name].length;
  });

  public selectRowOnInit = () => {
    const selectedRow = this.props?.controller[this.props?.selectRowObj];

    this.handleRowSelection(selectedRow);
  };

  public showHideFilters = (init = false) => {
    this.setShowFilters(!this.showFilters);

    if (this.showFilters === false) {
      this.setHeaderHeight(29);
    } else {
      this.setHeaderHeight(69);
    }

    // If the func called not from the initTable function, add the value to the cookies
    !init && this.setOptionsCookies("showFilters", this.showFilters);
  };

  public showHideColTotals = () => {
    this.showColTotals = !this.showColTotals;
  };

  public enableDisableFixedCols = (init = false) => {
    this.showFixedCols = !this.showFixedCols;

    // If the func called not from the initTable function, add the value to the cookies
    !init && this.setOptionsCookies("fixedColumns", this.showFixedCols);
  };

  public setOptionsCookies = (optionType, value) => {
    // get the options object if exists
    const options = JSON.parse(localStorage.getItem(this.dataObj + "Options")) || {};

    // Set particular option to its value
    options[optionType] = value;

    // Reset the whole options object to the cookies
    localStorage.setItem(this.dataObj + "Options", JSON.stringify(options));
  };

  public viewModeChange = action((value) => {
    switch (value) {
      case "compact":
        this.setTableRowHeight(24);
        break;

      case "detailed":
        this.setTableRowHeight(36);
        break;
      case "card":
        this.tableRowHeight = this.props?.tableCardHeight;
        break;
      default:
        this.setTableRowHeight(this.props?.tableRowHeight || 30);
        break;
    }

    this.setOptionsCookies("viewMode", value);
    this.viewMode = value;
  });

  public applyColumnConfig = action((config, columns, defaultConfig?) => {
    // Reset to default in case this func is called again from the import
    this.columnOrderDefault = [];
    this.columnOrderModal = [];
    this.columnOrder = [];

    let orderedColumns = [];

    // Add additional props to the original column structure
    columns.forEach((col) => {
      if (col.subColumns) {
        col.subColumns.forEach((subCol) => {
          // subCol['superHeader'] = { id: col.id, Header: col.Header, index: si + 1 }
          subCol["show"] = subCol.show !== undefined ? subCol.show : true;
        });
      }

      col["show"] = col.show !== undefined ? col.show : true;

      orderedColumns.push(col);
    });

    // Add column sequence to the default column order structure before applying config overrides
    orderedColumns.forEach((col) => {
      this.columnOrderDefault.push({
        show: col.show,
        Header: col.Header,
        subColumns:
          col.subColumns &&
          col.subColumns.map((sc) => {
            return {
              id: sc.id,
              Header: sc.Header,
              show: sc.show,
            };
          }),
        id: col.id,
      });
    });

    // Sort columns and sub columns
    config.forEach((col, i) => {
      const oldIndex = orderedColumns.findIndex((oc) => oc.id === col.id);

      // Check if the index is not -1
      if (~oldIndex) {
        const colToMove = orderedColumns[oldIndex];

        // Check if the original column is found
        if (colToMove) {
          // Check if the current column has sub columns. If so, sort them as well
          if (col.subColumns) {
            col.subColumns.forEach((subCol, subIndex) => {
              const subOldIndex = colToMove.subColumns.findIndex((subC) => subC.id === subCol.id);

              // Check if the index is not -1
              if (~subOldIndex) {
                const subColToMove = colToMove.subColumns[subOldIndex];

                // Apply config show state to the sub column
                subColToMove.show = subCol.show;

                // Check if the original sub column index is not -1
                if (~subOldIndex) {
                  colToMove.subColumns.splice(subOldIndex, 1);
                  colToMove.subColumns.splice(subIndex, 0, subColToMove);
                }
              }
            });
          }

          // Apply config show state to the column
          colToMove.show = col.show;

          // Sort columns
          orderedColumns.splice(oldIndex, 1);
          orderedColumns.splice(i, 0, colToMove);
        }
      }
    });

    // Prepare super headers and additional column props from the ordered column array
    orderedColumns.forEach((col) => {
      // Add each col to the column order to be shown in the column ordering modal
      this.columnOrder.push({
        show: col.show,
        Header: col.Header,
        subColumns:
          col.subColumns &&
          col.subColumns.map((sc) => {
            return {
              id: sc.id,
              Header: sc.Header,
              show: sc.show,
            };
          }),
        id: col.id,
      });
    });

    // Clone the column order to use for resetting the ordering in the modal
    this.columnOrderModal = defaultConfig || toJS(this.columnOrder);

    return orderedColumns;
  });

  public handleColumnReorder = action(({ oldIndex, newIndex }, superHeader = null) => {
    if (superHeader !== null) {
      const colToMove = this.columnOrder[superHeader].subColumns[oldIndex];

      this.columnOrder[superHeader].subColumns.splice(oldIndex, 1);
      this.columnOrder[superHeader].subColumns.splice(newIndex, 0, colToMove);
    } else {
      const colToMove = this.columnOrder[oldIndex];

      this.columnOrder.splice(oldIndex, 1);
      this.columnOrder.splice(newIndex, 0, colToMove);
    }
  });

  public pinRow = action((row, multi = false) => {
    if (multi) {
      Object.values(this.multiSelectedRows.rows).forEach((id: string) => {
        if (this.pinnedRows[id]) {
          delete this.pinnedRows[id];
        } else {
          this.pinnedRows[id] = [id];
        }
      });
    } else {
      if (this.pinnedRows[row._id]) {
        delete this.pinnedRows[row._id];
      } else {
        this.pinnedRows[row._id] = [row._id];
      }
    }

    // Force close context menu
    this.setContextMenu("show", false);
  });

  public resetPinnedRows = () => {
    this.pinnedRows = {};
  };

  // Can be called from the tables instance to recompute additional columns
  public computeColumns = action((cols) => {
    //Reset all values related with column computations as this function can be reused
    this.setTableColStructure(null, "width", {});

    this.setTableColStructureArray([]);
    this.setTotalColWidth(0);
    this.setSuperHeaders(null, "all", {});

    // console.log("cols ", cols);
    this.setOriginalTableCols(cols);

    if (this.props?.showCheckbox !== false) {
      this.tableColStructure["checkbox"] = {
        Header: <RenderCheckBox selectAll={true} controller={this} />,
        id: "checkbox",
        accessor: () => null,
        Cell: (data) => <RenderCheckBox row={data} controller={this} />,
        show: true,
        disableSortBy: true,
        disableFilters: true,
        disableResizing: true,
        animated: false,
        filterValue: "",
        finalFilterValue: "",
        filterType: "",
        width: this.checkboxColWidth,
      };

      this.setTotalColWidth(this.checkboxColWidth);
    }

    // Get the config for reordering columns from client settings
    if (this.props?.columnOrganiser) {
      const key = this.props?.columnOrganiser.columnReorderKey ? this.props.columnOrganiser.columnReorderKey(this.columnOrderKey) : this.columnOrderKey;

      this.columnReorderConfig = this.props?.columnOrganiser?.config(key) || [];
    }

    // Reorder/show/hide columns depending on the config
    const reorderedColumns = this.applyColumnConfig(this.columnReorderConfig, cols);
    // console.log(reorderedColumns); //qwerty
    // Add additional construction for each column
    reorderedColumns.forEach((col) => {
      if (col.subColumns) {
        col.subColumns.forEach((subCol) => {
          this.prepareColumns(subCol, col);
        });
      } else {
        this.prepareColumns(col);
      }
    });

    let keys = Object.keys(this.tableColStructure);
    if (!this.columnCardFlag) {
      let filteredColumns = keys.filter((ky) => ky !== "checkbox" && ky !== "OFTable_lastCol");

      if (filteredColumns.length === 0) {
        let foundCardIndex = this.props.columns.findIndex((col) => col.id === "card");

        if (foundCardIndex !== -1) {
          //passed column definitions has a card
          let columnCard = reorderedColumns[foundCardIndex];
          //columns which have the enableGlobalSearch set to true
          let filteredSearchColumns = reorderedColumns
            .filter((col) => col.enableGlobalSearch)
            .map(function (col) {
              return {
                name: col.Header,
                _id: col.id,
              };
            });

          let filteredKeys = filteredSearchColumns.map(function (col) {
            return col._id;
          });

          //Add Card Column
          this.tableColStructure["OFTable_Card"] = {
            Header: columnCard.Header,
            id: "OFTable_Card",
            accessor: columnCard.accessor,
            Cell: (data, value) => columnCard.Cell(data, value),
            show: true,
            disableSortBy: true,
            disableFilters: columnCard.disableFilters,
            disableResizing: true,
            filterValue: "",
            finalFilterValue: "",

            options: filteredSearchColumns,
            selectedCols: filteredKeys,

            width: window.screen.width,
            CardFilter: CSF.CardSearchFilter,
            filterMethod: CSF.FilteringMethod,
          };
          //change view mode to card so it resizes the row height accordingly
          this.viewModeChange("card");
          this.totalColWidth = window.screen.width;
        }
        //Allow delete functionality
        // delete this.tableColStructure['checkbox']
      } else {
        this.checkViewMode();
      }
    } else {
      this.checkViewMode();
    }

    // Add last column to fill the table size
    let lastCol = {
      Header: "",
      id: "OFTable_lastCol",
      accessor: () => null,
      Cell: () => null,
      show: true,
      disableSortBy: true,
      disableFilters: true,
      disableResizing: true,
      filterValue: "",
      finalFilterValue: "",
      filterType: "",
      width: 0,
    };

    this.setTableColStructure("OFTable_lastCol", "all", lastCol);

    // Make an array of columns for a better access with the index
    this.setTableColStructureArray(Object.values(this.tableColStructure));
    // Update last table column width after all the columns were computed
    // console.log('-------------')
    // console.log(this.tableListHeight)
    // console.log(this.tableRowHeight)
    // console.log(this.tableHeight)
    // console.log(this.innerHeight)
    // console.log(this.totalColWidth)
    // console.log('-------------')

    this.setLastColWidth();
  });

  public addKeyListeners = () => {
    keyboardJS.bind("down", null, (e) => {
      this.selectRowUsingKeys();
    });

    keyboardJS.bind("up", null, (e) => {
      this.selectRowUsingKeys(true);
    });

    if (this.props.selectRowUsingKeys.rightKeyAction) {
      keyboardJS.bind("right", (e) => {
        this.props.selectRowUsingKeys.rightKeyAction();
      });
    }

    if (this.props.selectRowUsingKeys.leftKeyAction) {
      keyboardJS.bind("left", (e) => {
        this.props.selectRowUsingKeys.leftKeyAction();
      });
    }
  };

  // Run sort and render test to see if all the columns can handle null/undefined values
  public debugTable = () => {
    this.tableColStructureArray.forEach((col) => {
      // Test sorting functions
      const value = col.accessor({});

      // Test rawValue handling
      if (col.rawValue) {
        col.rawValue({});
      }

      // test render function
      col.Cell({}, value);
    });

    // If UI is not crashing, return the success message
    message.success("Table Test Passed");
  };
}
